@if (currency() === 'key') {
	<picture>
		<source type="image/avif" srcset="/assets/images/common/icon-currency-key.avif" />
		<source type="image/webp" srcset="/assets/images/common/icon-currency-key.webp" />
		<source type="image/png" srcset="/assets/images/common/icon-currency-key.png" />
		<img
			i18n-alt="@@common.currency.key.alt"
			alt="Key currency icon"
			ngSrc="/assets/images/common/icon-currency-key.png"
			priority="true"
			width="97"
			height="101"
		/>
	</picture>
}

@if (currency() === 'ticket') {
	<picture>
		<source type="image/avif" srcset="/assets/images/common/icon-currency-ticket.avif" />
		<source type="image/webp" srcset="/assets/images/common/icon-currency-ticket.webp" />
		<source type="image/png" srcset="/assets/images/common/icon-currency-ticket.png" />
		<img
			i18n-alt="@@common.currency.ticket.alt"
			alt="Ticket currency icon"
			ngSrc="/assets/images/common/icon-currency-ticket.png"
			priority="true"
			width="138"
			height="94"
		/>
	</picture>
}
